// Controle do simulador de balança no canto da tela (só aparece com o
// simulador ligado neste computador): muda o peso "em cima da balança" em
// qualquer módulo, para treinar a equipe e demonstrar sem equipamento.
import { Scale, X } from "lucide-react";
import { useEffect, useState } from "react";

import { aoMudarSimulador, colocarPeso, pesoSimulado } from "./simulador";
import { useConfigBalanca } from "./useBalanca";

const ATALHOS = [0, 0.35, 0.486, 0.75, 1.2];
// Janela aberta (popup do produto, pesagem rápida) desliga o clique no resto da
// tela e fecha ao clicar fora: o simulador religa o clique nele e não deixa o
// toque chegar à janela — senão mexer no peso fechava o popup.
const naoFechaJanela = { style: { pointerEvents: "auto" }, onPointerDown: (e) => e.stopPropagation() };
const kgTexto = (kg) => `${Number(kg || 0).toFixed(3).replace(".", ",")} kg`;

export default function SimuladorFlutuante() {
  const cfg = useConfigBalanca();
  const [kg, setKg] = useState(pesoSimulado());
  const [aberto, setAberto] = useState(true);
  useEffect(() => aoMudarSimulador(setKg), []);
  if (!cfg.ativa || cfg.conexao !== "simulador") return null;

  if (!aberto) {
    return (
      <button type="button" onClick={() => setAberto(true)} data-e2e="simulador-balanca-abrir" {...naoFechaJanela}
        className="fixed bottom-4 left-4 z-[60] h-10 px-3 rounded-full bg-zinc-900 text-white text-sm font-semibold shadow-lg inline-flex items-center gap-2">
        <Scale className="w-4 h-4" /> {kgTexto(kg)}
      </button>
    );
  }
  return (
    <div className="fixed bottom-4 left-4 z-[60] w-64 rounded-xl border bg-card shadow-xl p-3 space-y-2" data-e2e="simulador-balanca" {...naoFechaJanela}>
      <div className="flex items-center gap-2">
        <Scale className="w-4 h-4 text-orange-500" />
        <p className="text-sm font-semibold flex-1">Simulador de balança</p>
        <button type="button" onClick={() => setAberto(false)} aria-label="Recolher" className="text-muted-foreground hover:text-foreground">
          <X className="w-4 h-4" />
        </button>
      </div>
      <p className="text-2xl font-black tabular-nums text-center" data-e2e="simulador-balanca-peso">{kgTexto(kg)}</p>
      <input type="range" min="0" max="3" step="0.005" value={kg} onChange={(e) => colocarPeso(Number(e.target.value))}
        className="w-full accent-orange-500" data-e2e="simulador-balanca-regua" />
      <div className="grid grid-cols-5 gap-1">
        {ATALHOS.map((v) => (
          <button key={v} type="button" onClick={() => colocarPeso(v)} data-e2e={`simulador-balanca-${v}`}
            className="h-7 rounded-md bg-muted hover:bg-muted/70 text-[10px] font-bold">
            {v === 0 ? "Vazia" : v.toFixed(3).replace(".", ",")}
          </button>
        ))}
      </div>
    </div>
  );
}
